import React from "react";
import styles from "./styles.module.css";

export const PageLayout: React.FC = (props) => {
  return <div className={styles.pageLayout}>{props.children}</div>;
};

export default PageLayout;
